import { Dialog, useTheme } from '@mui/material';
import { makeStyles } from '~/UIKit/Style';
import React from 'react';
import cn from 'classnames';
interface ModalComponentProps {
  onClose: () => void;
  open: boolean;
  children: React.ReactNode;
  isFullHeight?: boolean;
  noPadding?: boolean;
}

const useStyles = (isFullHeight: boolean) =>
  makeStyles((theme) => ({
    paper: {
      width: '100%',
      maxWidth: '100%',
      borderRadius: isFullHeight ? 0 : '6px 6px 0 0',
      height: isFullHeight && '100%',
      maxHeight: isFullHeight && '100%',
      margin: 0,
      display: 'grid',
      gridTemplateRows: 'max-content 1fr max-content',
      [theme.breakpoints.up('md')]: {
        padding: '0 24px 16px',
        borderRadius: 6,
        maxWidth: 600,
      },
    },
    container: {
      alignItems: 'end',
      [theme.breakpoints.up('md')]: {
        alignItems: 'center',
      },
    },
    noPadding: {
      padding: 0,
    },
  }));

const ModalComponent = ({
  children,
  onClose,
  open,
  isFullHeight = false,
  noPadding = false,
}: ModalComponentProps) => {
  const theme = useTheme();
  const { classes } = useStyles(isFullHeight)(theme);

  return (
    <Dialog
      classes={{
        paper: cn(classes.paper, { [classes.noPadding]: noPadding }),
        container: classes.container,
      }}
      aria-labelledby="dialog-title"
      onClose={onClose}
      open={open}
      data-testid="modal"
    >
      {children}
    </Dialog>
  );
};

export default ModalComponent;
